export enum ModelosAssinaturasEletronicasEnum {
    carregada = 'carregada',
    desenho = 'desenho',
    escrita = 'escrita'
}
